import Animation from '../../animations/entering-animation'
import StyleTweeners from '../style-tweeners'

class EnteringAnimation extends Animation {

  constructor (options) {
    super(options)
    this.styleTweeners = new StyleTweeners(this.styles)
  }

  animate (serie, entering, selection, merged, exiting) {
    this._initialInsert(entering) // Get the elements in the DOM

    this._walkLine(entering, exiting, this._growPath)

    merged.tween('shrink-stroke', this.styleTweeners.shrinkStroke(merged))
          .tween('fade-in', this.styleTweeners.fadeIn(merged))
  }
}

export default EnteringAnimation
